import { render, staticRenderFns } from "./CommunityConfiguration.vue?vue&type=template&id=dc9125e6&"
import script from "./CommunityConfiguration.vue?vue&type=script&lang=js&"
export * from "./CommunityConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports